
import { ButtonStylesProcessor } from './ButtonStylesProcessor';
import { GridStylesProcessor } from './GridStylesProcessor';
import { CardStylesProcessor } from './CardStylesProcessor';
import { SpacingStylesProcessor } from './SpacingStylesProcessor';
import { TextStylesProcessor } from './TextStylesProcessor';

/**
 * EssentialStylesProcessor - Creates inline styles for essential component styling
 */
export class EssentialStylesProcessor {
  static createEssentialStyles(): HTMLStyleElement {
    console.log(`[DEBUG] EssentialStylesProcessor: Creating essential styles`);
    const style = document.createElement('style');
    
    // Combine all styles from different processors
    style.textContent = `
      /* Essential calculator container styles */
      .onexip-calculator-container {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
        color: #0f172a !important;
        box-sizing: border-box !important;
        line-height: 1.5 !important;
        max-width: 100% !important;
        background-color: #fff !important;
        border-radius: 0.5rem !important;
        overflow: hidden !important;
        margin: 0 auto !important;
        padding: 0 !important;
      }

      ${ButtonStylesProcessor.createButtonStyles()}
      ${GridStylesProcessor.createGridStyles()}
      ${CardStylesProcessor.createCardStyles()}
      ${SpacingStylesProcessor.createSpacingStyles()}
      ${TextStylesProcessor.createTextStyles()}
    `;
    
    return style;
  }
}
